import React, { useEffect, useState, useRef } from 'react';
import Player from './../player/Player';
import Performances from './../player/Performances';
import NewTracks from './../views/NewTracks';
import Grid from '@mui/material/Grid';
import navigationStore from './../../stores/navigation';
import { Views } from './../../enums/enums';
import ContainerLeft from '../items/ContainerLeft';
import ContainerRight from '../items/ContainerRight';
import Catalog from './Catalog';
import Search from './Search';
import Favorites from './Favorites';
import Singers from './Singers';
import Home from './Home';
import BackgroundMusic from './BackgroundMusic';
import PlayLists from './PlayLists';
import Settings from './Settings';
import Account from './Account';
import Feedback from './Feedback';
import ChangePassword from './ChangePassword';
import ChangeUsername from './ChangeUsername';
import playerStore from './../../stores/player';
import BgPlayer from './BgPlayer';
import BgPlaylists from './BgPlaylists';
import BgSearch from './BgSearch';
import BgStyles from './BgStyles';
import ContentContainer from '../items/ContentContainer';

function Container() {

  const safeArea = navigationStore((state) => state.safeArea);

  return (
    <Grid id="muvika-performance-grid" container sx={{ paddingTop: safeArea ? "calc("+safeArea.top + "px + 4rem)" : "3.75rem !important" }}>
      <ContainerLeft />
      <ContainerRight />
    </Grid>
  );
}

export default Container;